import React from 'react';
import type { VisualFractionPart } from '../types';
import { getInteractiveProps } from './part-interactions';
import { getCircleSectorProps } from '../../../utils/visual-fraction-geometry';

interface CircleShapeProps {
  parts: VisualFractionPart[];
  divisions: number;
  onPartClick: (index: number) => void;
}

export const CircleShape: React.FC<CircleShapeProps> = ({
  parts,
  divisions,
  onPartClick,
}) => (
  <svg
    className="visual-fraction-widget__shape visual-fraction-widget__circle"
    viewBox="0 0 100 100"
  >
    {parts.map(part => {
      const sectorProps = getCircleSectorProps(part.index, divisions);
      const className = `${part.className} visual-fraction-widget__sector`;
      const interactiveProps = getInteractiveProps(part, onPartClick);

      return sectorProps.kind === 'circle' ? (
        <circle
          key={part.index}
          className={className}
          style={part.style}
          cx="50"
          cy="50"
          r="48"
          {...interactiveProps}
        />
      ) : (
        <path
          key={part.index}
          className={className}
          style={part.style}
          d={sectorProps.d}
          {...interactiveProps}
        />
      );
    })}
  </svg>
);

CircleShape.displayName = 'CircleShape';
